<template>
    <div
    :cn="componentName"
    v-if="open"
    class="dialog flex overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-40 justify-center items-center md:inset-0 h-modal sm:h-full bg-gray-900 bg-opacity-70">
    <div class="relative px-4 w-full max-w-xl h-full md:h-auto" style="height: calc(100% - 3.5rem);">
        <!-- Modal content -->
        <div class="modal-content relative flex flex-col overflow-hidden max-h-full bg-white rounded-md shadow dark:bg-slate-800">
            <!-- Modal header -->
            <div class="flex flex-shrink-0 justify-between items-center pl-3 p-2 rounded-t border-b dark:border-gray-600">
                <h3 class="text-xl font-medium text-gray-900 dark:text-white">
                    <slot name="title">{{ title }}</slot>
                </h3>
                <button
                @click="$emit('close')"
                 type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-md text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </button>
            </div>
            <!-- Modal body -->
            <div class="p-6 overflow-auto">
                <slot name="content">
                    Overwrite my slot
                </slot>
            </div>
            <!-- Modal footer -->
            <div v-if="showFooter" class="flex flex-shrink-0 justify-end p-4 space-x-2 rounded-b border-gray-200 dark:border-gray-600">
                <slot name="footer">
                    <custom-button
                    predefinedStyle="transparent"
                    @click.prevent="$emit('close')"
                    >
                        <template v-slot:label>
                        {{__('labels.basics.cancel')}}
                        </template>
                    </custom-button>


                    <custom-button
                    predefinedStyle="default"
                    @click.prevent="$emit('modal:save')"
                    >
                        <template v-slot:label>
                        {{__('labels.basics.save_changes')}}
                        </template>
                    </custom-button>
                </slot>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import CustomButton from '../basics/CustomButton.vue';
export default {
    components : {
        CustomButton
    },
    props: {
        open:{
            default: false,
            type: Boolean,
        	required: true,
        },
        title: String,
        showFooter:{
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            background : false,
        };
    },
    computed: {
        componentName(){
            return "md-modal";
        },
        modalTitle(){
            return this.title;
        },
    }
}
</script>
